import { useMemo, useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import {
  Button,
  Divider,
  Group,
  Modal,
  Select,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { IconWorldSearch } from "@tabler/icons-react";
import { useProfileStore } from "../../../../../stores/UserStore";
import { useConfigStore } from "../../../../../stores/ConfigStore";
import EnrichDatafieldExternal from "./EnrichDatafieldExternal";
import EnrichDatafieldLocal from "./EnrichDatafieldLocal";
import BackButton from "../../../../../components/View/BackButton";
import { getPermission } from "../../../../../functions/utilFunctions";

const kasprFieldId = 7;

const EnrichDatafield = ({ defaultDatafieldId, closeMenu, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [opened, { open, close }] = useDisclosure();

  const datafields = useConfigStore((s) => s.datafields);
  const [datafieldId, setDatafieldId] = useState(defaultDatafieldId);
  const [isKaspr, setIsKaspr] = useState(defaultDatafieldId === kasprFieldId);

  const enrichable = useMemo(() => {
    let result = [1, 6, 7, 13, 18, 19];

    if (!getPermission("findMobilePhone")) {
      result = result.filter((x) => x !== 7);
    }

    if (!getPermission("aiPerplexity")) {
      result = result.filter((x) => x !== 1);
    }

    return result;
  }, []);

  const handleOpen = (e) => {
    open();
    e.stopPropagation();
  };

  const handleChange = (v) => {
    let newValue = parseInt(v);
    setDatafieldId(newValue);

    if (newValue === kasprFieldId) {
      setIsKaspr(true);
    } else {
      setIsKaspr(false);
    }
  };

  const handleClose = () => {
    close();
    closeMenu?.();
  };

  if (
    !profile?.permissions?.find((x) => x.name === "generateDatafieldAi")
      ?.value === true
  ) {
    return "";
  }

  return (
    <>
      <Button
        variant="light"
        className="to-blue"
        onClick={handleOpen}
        justify="start"
        size="md"
      >
        <Group gap={4}>
          <ThemeIcon variant="subtle" p={0}>
            <IconWorldSearch size={18} />
          </ThemeIcon>
          {lang.contact_lists.datafield_content.label_enrich}
        </Group>
      </Button>

      {opened && (
        <Modal
          opened={opened}
          size={"md"}
          onClose={handleClose}
          title={lang.prospects.enrich_field}
          styles={{
            title: {
              lineHeight: 1.5,
            },
          }}
        >
          <Select
            data={enrichable.map((id) => ({
              label: datafields.find((x) => x.id === id)?.name,
              value: id.toString(),
            }))}
            value={datafieldId?.toString()}
            onChange={handleChange}
            label={lang.prospects.enrich_field_label}
            placeholder={lang.prospects.enrich_field_placeholder}
            mb={16}
            size="md"
          />

          {datafieldId && <Divider mb={16} />}

          {datafieldId ? (
            isKaspr ? (
              <EnrichDatafieldExternal
                datafieldId={datafieldId}
                handleClose={handleClose}
                onFinish={onFinish}
              />
            ) : (
              <EnrichDatafieldLocal
                datafieldId={datafieldId}
                handleClose={handleClose}
                onFinish={onFinish}
              />
            )
          ) : (
            <Group justify="end">
              <BackButton onClick={handleClose} size="md" />
            </Group>
          )}
        </Modal>
      )}
    </>
  );
};

export default EnrichDatafield;
